<template>
  <div class="my">
    <Header></Header>
    <Nav></Nav>
    <Toptitle title="个人中心"></Toptitle>
    <div class="my_c">
      <div class="my_left">
        <div class="my_head">
          <img  :src="!userInfo.header? headImg:userInfo.header" alt="" >
          <input type="file" @change="upheadImg($event)" accept="image/*" id="imgfile"/>
        </div>
        <p class="my_name">{{userInfo.nickname}}</p>
        <a :class="['my_item',tip==1 ||tip ==4?'choice':'']" @click="tip =1,getMemberArticaleList(1),listJson.pageNo = 1">
          <div>
            <img src="../assets/static/images/myIcon2.png" alt="" v-if="tip == 1 || tip==4">
            <img src="../assets/static/images/myIcon5.png" alt="" v-else>
            <span>我的行记</span>
          </div>
          <img src="../assets/static/images/myIcon6.png" alt="" class="my_item_right">
        </a>
        <a :class="['my_item',tip==2|| tip==5?'choice':'']" @click="tip =2,getMemberArticaleList(2),listJson.pageNo = 1">
          <div>
            <img src="../assets/static/images/myMitoIcon.png" alt="" v-if="tip == 2 || tip ==5">
            <img src="../assets/static/images/myIcon3.png" alt="" v-else>
            <span>我的美图</span>
          </div>
          <img src="../assets/static/images/myIcon6.png" alt="" class="my_item_right">
        </a>
        <a :class="['my_item',tip==3?'choice':'']" @click="tip =3">
          <div>
            <img src="../assets/static/images/myInformationIcon.png" alt="" v-if="tip==3">
            <img src="../assets/static/images/myIcon4.png" alt="" v-else>
            <span>个人信息</span>
          </div>
          <img src="../assets/static/images/myIcon6.png" alt="" class="my_item_right">
        </a>
        <a :class="['my_item',tip==6 || tip==7 ?'choice':'']" @click="tip =6,getMyList()">
          <div>
            <img src="../assets/static/images/myIcon7.png" alt="" v-if="tip==6">
            <img src="../assets/static/images/myIcon7.png" alt="" v-else>
            <span>我的报名</span>
          </div>
          <img src="../assets/static/images/myIcon6.png" alt="" class="my_item_right">
        </a>
        <a :class="['my_item',tip==8 || tip==9 ?'choice':'']" @click="tip =8,getMemberArticaleList(3),listJson.pageNo = 1">
          <div>
            <img src="../assets/static/images/myIcon7.png" alt="" v-if="tip==6">
            <img src="../assets/static/images/myIcon7.png" alt="" v-else>
            <span>我的参赛作品</span>
          </div>
          <img src="../assets/static/images/myIcon6.png" alt="" class="my_item_right">
        </a>
      </div>
      <div class="my_left750" v-if="showLeft750">
        <div class="my_head">
          <img  :src="!userInfo.header? headImg:userInfo.header" alt="" >
          <input type="file" @change="upheadImg($event)" accept="image/*" id="imgfile"/>
        </div>
        <p class="my_name">{{userInfo.nickname}}</p>
        <a class="my_item" @click="showLeft750=false,tip=1,getMemberArticaleList(1),listJson.pageNo = 1">
          <div>
            <img src="../assets/static/images/myIcon5.png" alt="">
            <span>我的行记</span>
          </div>
          <img src="../assets/static/images/myIcon6.png" alt="" class="my_item_right">
        </a>
        <a class="my_item" @click="showLeft750=false,tip=2,getMemberArticaleList(2),listJson.pageNo = 1">
          <div>
            <img src="../assets/static/images/myIcon3.png" alt="">
            <span>我的美图</span>
          </div>
          <img src="../assets/static/images/myIcon6.png" alt="" class="my_item_right">
        </a>
        <a class="my_item" @click="showLeft750=false,tip=3">
          <div>
            <img src="../assets/static/images/myIcon4.png" alt="">
            <span>个人信息</span>
          </div>
          <img src="../assets/static/images/myIcon6.png" alt="" class="my_item_right">
        </a>
        <a class="my_item" @click="showLeft750=false,tip=6,getMyList()">
          <div>
            <img src="../assets/static/images/myIcon7.png" alt="">
            <span>我的报名</span>
          </div>
          <img src="../assets/static/images/myIcon6.png" alt="" class="my_item_right">
        </a>
        <a class="my_item" @click="showLeft750=false,tip=8,getMemberArticaleList(3),listJson.pageNo = 1">
          <div>
            <img src="../assets/static/images/myIcon7.png" alt="">
            <span>我的参赛作品</span>
          </div>
          <img src="../assets/static/images/myIcon6.png" alt="" class="my_item_right">
        </a>
      </div>
      <!-- 我的行记 -->
      <div :class="['my_right',!showLeft750 && tip==1?'showRight' : '']" v-show="tip == 1">
        <div class="return750" @click="reback()">
          <img src="../assets/static/images/returnIcon.png" />
        </div>
        <div class="my_right_tit">
          <div class="my_right_tit_div" @click="getMemberArticaleList(1),handleCurrentChange(1),listJson.pageNo = 1">
            <img src="../assets/static/images/myIcon1.png" alt="" class="myIcon1">
            <h3>我的行记</h3>
          </div>
          <div class="add_my"  @click="tip = 4,listId=''">
            <div class="add_my_icon">
              <img src="../assets/static/images/writeIcon.png" />
            </div>
            <span class="add_my_tit">写行记</span>
          </div>
        </div>
        <div class="my_right_c" v-if="ArticaleList.length>0">
          <div class="activitiesCommunity_item" v-for="(item,index) of ArticaleList" :key="index" @click="listId = item.id,tip = 4">
            <div class="activitiesCommunity_item_img" :style="{ 'background': 'url(' +item.picture+ ') no-repeat center center', 'background-size': 'cover'}"></div>
            <div class="activitiesCommunity_item_right">
              <h3>{{item.title}}<b class="red">({{statusarr[item.status]}})</b></h3>
              <p>{{item.subtitle}}</p>
              <div>
                <span><img src="../assets/static/images/activitiesCommunityIcon1.png" alt="">{{item.authorname}}</span>
                <span><img src="../assets/static/images/activitiesCommunityIcon2.png" alt="">{{!item.zuan ? 0 : item.zuan}}</span>
                <span><img src="../assets/static/images/activitiesCommunityIcon3.png" alt="">{{!item.commentNumber ? 0 : item.commentNumber}}</span>
              </div>
            </div>
          </div>
          <el-pagination background small layout="prev, pager, next" @current-change="handleCurrentChange" :page-size='listJson.pageSize'
            :total="totalRecord" class="newspage" :current-page="listJson.pageNo" prev-text='< 上一页' next-text='下一页 >'></el-pagination>
        </div>
        <div class="null" v-else>
          暂无数据
        </div>
      </div>
      <!-- 我的美图 -->
      <div :class="['my_right',!showLeft750&& tip==2?'showRight' : '']" v-show="tip == 2">
        <div class="return750" @click="reback">
          <img src="../assets/static/images/returnIcon.png" />
        </div>
        <div class="my_right_tit">
          <div class="my_right_tit_div">
            <img src="../assets/static/images/myIcon1.png" alt="" class="myIcon1">
            <h3>我的美图</h3>
          </div>
          <div class="add_my" @click="tip =5,listId=''">
            <div class="add_my_icon">
              <img src="../assets/static/images/uploadMitoIcon.png" />
            </div>
            <span class="add_my_tit">上传美图</span>
          </div>
        </div>
        <div class="my_right_c_Mito" v-if="ArticaleList.length>0">
          <div  class="my_right_c_MitoItem" v-for="(item,index) of ArticaleList" :key="index" @click="tip = 5,listId=item.id">
            <img :src="item.picture">
            <p class="my_right_c_MitoItem_p">{{item.title}}</p>
          </div>          
        </div>
        <div class="null" v-else>
           暂无数据
        </div>
        <el-pagination background small layout="prev, pager, next" @current-change="handleCurrentChange" :page-size='listJson.pageSize'
            :total="totalRecord" class="newspage" :current-page="listJson.pageNo" prev-text='< 上一页' next-text='下一页 >'></el-pagination>
      </div>
      <!-- 个人信息 -->
      <div :class="['my_right',!showLeft750&& tip==3?'showRight' : '']" v-show="tip == 3">
        <div class="return750" @click="reback()">
          <img src="../assets/static/images/returnIcon.png" />
        </div>
        <div class="my_right_tit">
          <div class="my_right_tit_div">
            <img src="../assets/static/images/myIcon1.png" alt="" class="myIcon1">
            <h3>个人信息</h3>
          </div>
        </div>
        <div class="my_right_c_Information">
          <el-form class="my_right_c_info_ul">
            <el-form-item>
              <span class="my_right_c_info_span info_span_2">昵&nbsp;&nbsp;&nbsp;称：</span>
              <el-input v-model="userInfo.nickname" class="my_right_c_info_input" clearable></el-input>
            </el-form-item>
            <!-- <el-form-item>
              <span class="my_right_c_info_span info_span_2">姓&nbsp;&nbsp;&nbsp;名：</span>
              <el-input v-model="dataJson.name" class="my_right_c_info_input" clearable></el-input>
            </el-form-item> -->
            <li>
              <span class="my_right_c_info_span info_span_phone">手机号：</span>
              <div class="modify_div" v-show="showModify_div">
                <span>{{userInfo.phone}}</span>
                <span class="modify_span" @click="modify_phone">修改手机号>></span>
              </div>
              <div class="ver_div" v-show="showVer_div">
                <ul>
                  <li class="ver_text">绑定新手机号完善信息后可用新手机号验证登录</li>
                  <li>
                    <el-input placeholder="请输入新的手机号码" v-model="phoneJson.phone"></el-input>
                  </li>
                  <li>
                    <el-input placeholder="请输入图形验证码" class="ver_codeInput" v-model="phoneJsonimgcode"></el-input>
                    <div>
                      <img :src="codeImg" v-if="codeImg" @click="getImgCode()"/>
                    </div>
                  </li>
                  <li>
                    <el-input placeholder="请输入验证码" class="ver_codeInput" v-model="phoneJson.code"></el-input>
                    <div class="ver_sendCode" @click="getCode()">{{codeText}}</div>
                  </li>
                  <li>
                    <div class="ver_cancelBtn ver_poBtn" @click="ver_cancel">取消</div>
                    <div class="ver_confirmBtn ver_poBtn" @click="ver_confirm">确定</div>
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <span class="my_right_c_info_span info_span_2">性&nbsp;&nbsp;&nbsp;别：</span>
              <el-radio-group v-model="userInfo.sex">
                <el-radio :label="1">男</el-radio>
                <el-radio :label="0">女</el-radio>
              </el-radio-group>
            </li>
            <li>
              <span class="my_right_c_info_span">出生日期：</span>
              <el-date-picker type="date" placeholder="选择日期" v-model="userInfo.birthday"></el-date-picker>
            </li>
            <div class="info_saveBtn" @click="updateInfo()">保存</div>
          </el-form>
        </div>
      </div>
      <!-- 我的报名 -->
      <div :class="['my_right',!showLeft750 && tip==6?'showRight' : '']" v-show="tip == 6">
        <div class="return750" @click="reback()">
          <img src="../assets/static/images/returnIcon.png" />
        </div>
        <div class="my_right_tit">
          <div class="my_right_tit_div">
            <img src="../assets/static/images/myIcon1.png" alt="" class="myIcon1">
            <h3>我的报名</h3>
          </div>
        </div>
        <div class="my_right_c" v-if="getMyListARR.length>0">
          <div class="activitiesCommunity_item" v-for="(item,index) of getMyListARR" :key="index">
            <div class="activitiesCommunity_item_img" :style="{ 'background': 'url(' + item.picture+ ') no-repeat center center', 'background-size': 'cover'}"></div>
            <div class="activitiesCommunity_item_right">
              <h3>{{item.activityname}}</h3>
              <p>举办单位:{{item.holder}}</p>
              <!-- ,tip=7, -->
              <p><span @click="uploadworks(item),activityid = item.activityid,listId=''" class="examined_btn">上传作品</span></p>
            </div>
          </div>
        </div>
        <div class="null" v-else>
           暂无数据
        </div>
         <el-pagination background small layout="prev, pager, next" @current-change="handleCurrentChange1" :page-size='getMyListjson.pageSize'
            :total="totalRecord" class="newspage" :current-page="getMyListjson.pageNo" prev-text='< 上一页' next-text='下一页 >'></el-pagination>
      </div>

      <!-- 写行记 -->
      <div :class="['my_right',!showLeft750&& tip==4?'showRight' : '']" v-show="tip == 4">
        <div class="return750" @click="tip = 1">
          <img src="../assets/static/images/returnIcon.png" />
        </div>
        <addMyDeeds v-if="tip == 4" classTyle="1" :id="listId"></addMyDeeds>
      </div>
      <!-- 上传美图 -->
      <div :class="['my_right',!showLeft750&& tip==5?'showRight' : '']" v-show="tip == 5">
        <div class="return750" @click="tip = 2">
          <img src="../assets/static/images/returnIcon.png" />
        </div>
        <addMyDeeds v-if="tip == 5" classTyle="2" :id="listId"></addMyDeeds>
      </div>
      <!-- 我的报名 -->
      <div :class="['my_right',!showLeft750&& tip==7?'showRight' : '']" v-show="tip == 7">
        <div class="return750" @click="tip = 2">
          <img src="../assets/static/images/returnIcon.png" />
        </div>
        <addMyDeeds v-if="tip == 7" classTyle="3" :activityid="activityid" :id="listId" ></addMyDeeds>
      </div>
      <!-- 我的参赛作品 -->
      <div :class="['my_right',!showLeft750 && tip==8?'showRight' : '']" v-show="tip == 8">
        <div class="return750" @click="reback()">
          <img src="../assets/static/images/returnIcon.png" />
        </div>
        <div class="my_right_tit">
          <div class="my_right_tit_div" @click="getMemberArticaleList(1),handleCurrentChange(1),listJson.pageNo = 1">
            <img src="../assets/static/images/myIcon1.png" alt="" class="myIcon1">
            <h3>我的参赛作品</h3>
          </div>
        </div>
        <div class="my_right_c" v-if="ArticaleList.length>0">
          <div class="activitiesCommunity_item" v-for="(item,index) of ArticaleList" :key="index" @click="listId=item.id,tip=7">
            <div class="activitiesCommunity_item_img" :style="{ 'background': 'url(' +item.picture+ ') no-repeat center center', 'background-size': 'cover'}"></div>
            <div class="activitiesCommunity_item_right">
              <h3>{{item.title}}<b class="red">({{statusarr[item.status]}})</b></h3>
              <p>{{item.subtitle}}</p>
              <div>
                <span><img src="../assets/static/images/activitiesCommunityIcon1.png" alt="">{{item.authorname}}</span>
                <!-- <span><img src="../assets/static/images/activitiesCommunityIcon2.png" alt="">{{!item.zuan ? 0 : item.zuan}}</span>
                <span><img src="../assets/static/images/activitiesCommunityIcon3.png" alt="">{{!item.zuan ? 0 : item.zuan}}</span> -->
              </div>
            </div>
          </div>
          <el-pagination background small layout="prev, pager, next" @current-change="handleCurrentChange" :page-size='listJson.pageSize'
            :total="totalRecord" class="newspage" :current-page="listJson.pageNo" prev-text='< 上一页' next-text='下一页 >'></el-pagination>
        </div>
        <div class="null" v-else>
           暂无数据
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<style>
.el-form-item__content{display: flex;justify-content: flex-start;align-items: center;}
.my_head{position: relative;}
.my_head img{width: 100%;height: 100%;display:block;border-radius: 50%;object-fit: cover;}
.my_head input{position: absolute;top: 0;left: 0;width: 100%;height: 100%;opacity: 0;}
b.red{color: red;font-weight: 500;font-size: 14px;}
.examined_btn{width: 80px;height: 30px;display: flex;align-items: center;border-radius: 5px;background: #B83113;color: #fff!important;justify-content: center!important;cursor: pointer;}
</style>
<script>
  import Header from './common/Header.vue'
  import Nav from './common/Nav.vue'
  import Footer from './common/Footer.vue'
  import Toptitle from './common/Toptitle.vue'
  import addMyDeeds from './common/addMyDeeds.vue'
  export default {
    data() {
      return {
        listId:'',
        statusarr:['未审核','审核通过','审核不通过'],
        dataJson: {
          nickName: '',
          name: '',
          phone: '',
          gender: 0,
          birthday: ''
        },
        tip: 1,
        showModify_div: true,
        showVer_div: false,
        showLeft750: true,
        showRight750: false,
        headImg: require('../assets/static/img/headImg.png'),
        userinfoId: '',
        userInfo: [],
        listJson:{
          type:1,
          pageNo:1,
          pageSize:10,
          userid:''
        },
        getMyListjson:{
          pageNo:1,
          pageSize:10,
        },
        getMyListARR:[],
        ArticaleList:[],
        totalRecord:0,
        activityid:'',
        codeImg:'',
        sessionId:'',
        phoneJson:{
          id:'',
          phone:'',
          code:'',
          sessionid:''
        },
        phoneJsonimgcode:'',
        codeText:'获取验证码',
        time:60,
        timer:''
      }
    },
    components: {
      Header,
      Footer,
      Nav,
      Toptitle,
      addMyDeeds
    },
    methods: {
      uploadworks(item){
        if(new Date(item.endtime)<new Date()){
            this.$message({
              message: "活动已结束,不能上传作品",
              type: 'warning'
            });
            return;
        }
        this.tip=7
      },
      modify_phone() {
        this.showModify_div = false
        this.showVer_div = true
      },
      ver_cancel() {
        this.showVer_div = false
        this.showModify_div = true
      },
      ver_confirm() {
        this.showVer_div = false
        this.showModify_div = true
        this.phoneJson.id = this.userinfoId
        this.axios.post('api/u_member/updatePhone.do',this.qs(this.phoneJson))
        .then(res =>{
          if(res.data.code == 0){
            this.updateInfo()     
          }else{
            this.$message.error("更新失败！")
          }
         
        })
      },
      reback() {
        this.showLeft750 = true
      },
      getUserInfo() {
        this.axios.post('/api/u_member/getDetail.do', this.qs({
          id: this.userinfoId
        })).then(res => {
          if (res.status == 200) {
            this.userInfo = res.data.data
            sessionStorage.setItem("userInfo",JSON.stringify(this.userInfo))
            if (localStorage.getItem('userInfoId')) {
              localStorage.setItem('token', res.data.token)
            }
            if (sessionStorage.getItem('userInfoId')) {
              sessionStorage.setItem('token', res.data.token)
            }
          }
        })
      },
      getMemberArticaleList(type){
        this.listJson.type = type
        this.listJson.userid = this.userinfoId,
        this.axios.post('api/c_article/getMemberArticaleList.do',this.qs(this.listJson))
        .then(res =>{
          this.totalRecord = res.data.totalRecord
          this.ArticaleList = res.data.results
          this.listJson.pageNo = res.data.pageNo
           window.scrollTo({
             top:100,
             behavior:'smooth'
           })
        })
      },
      //我的报名
      getMyList(){
        this.axios.post('api/a_useractivity/getMyList.do',this.qs(this.getMyListjson))
        .then(res =>{
          this.totalRecord = res.data.data.totalRecord
          this.getMyListARR = res.data.data.results
          this.getMyListjson.pageNo = res.data.data.pageNo
           window.scrollTo({
             top:100,
             behavior:'smooth'
           })
        })
      },
      handleCurrentChange(val) {
        this.listJson.pageNo = val
        this.getMemberArticaleList(this.listJson.type)
      },
      handleCurrentChange1(val){
        this.getMyListjson.pageNo = val
        this.getMyList()
      },
      //修改用户信息
      updateInfo(){
        if(!this.userInfo.nickname){
          this.$message.error("昵称不能为空")
          return;
        }
        if(!this.userInfo.sex && this.userInfo.sex !=0){
          this.$message.error("性别不能为空")
          return;
        }
        if(!this.userInfo.birthday){
          this.$message.error("出生日期不能为空")
          return;
        }
        var userInfojson ={
          nickname:this.userInfo.nickname,
          id:this.userInfo.id,
          header:this.userInfo.header,
          sex:this.userInfo.sex,
          birthday:this.$moment(this.userInfo.birthday).format('YYYY-MM-DD HH:mm:ss'),
        }
        this.axios.post('api/u_member/update.do',this.qs(userInfojson))
        .then(res =>{
          if(res.data.code == 0){
            this.getUserInfo()
            this.$message.success(res.data.message)
          }else{
            this.$message.success("更新失败！")
          }
        })
        console.log(this.userInfo.birthday);
      },
      //修改头像
      upheadImg(event){
        let param = new FormData(); 
        var timestamp = Date.parse(new Date());
        var file = event.target.files[0]
        var name = event.target.files[0].name
        console.log(name);
        param.append('file',file,timestamp+name);
        this.axios.post('api/upload/uploadFile.do',param)
        .then(res => {
          document.getElementById('imgfile').value = ''
          if(res.data.resultCode == 0){  
            this.userInfo.header = res.data.data.fileUrl
            this.updateInfo()      
          }
        })  
      },
      //获取验证码
      getCode() {
        if (!this.$isTelAvailable(this.phoneJson.phone)) {
         this.$message.error("手机格式有误")
          return
        }
        if (this.phoneJsonimgcode == '') {
          this.$message.error("图形验证码不能为空")
          return
        } 
        if (this.codeText == '获取验证码') {
          this.timer = setInterval(() => {
            this.time--;
            this.codeText = '剩余' + this.time + 's'
            if (this.time == 0) {
              this.codeText = '获取验证码'
              this.time = 60
              clearInterval(this.timer)
            }
          }, 1000)
          this.sendSms()
        }
      },
      //获取图片验证码
      getImgCode() {
        this.axios.post('verifycode/getImageCodeB64.do', this.qs({
          width: 160,
          height: 36,
          isNeedPrefix: 1
        })).then(res => {
          if (res.status == 200) {
            this.codeImg = res.data.image
            this.sessionId = res.data.sessionId
          }
        })
      },
      sendSms() {
        this.axios.post('/api/index/getVerifyCode.do', this.qs({
          phone: this.phoneJson.phone,
          verifycode: this.phoneJsonimgcode,
          sessionid: this.sessionId
        })).then(res => {
          if(res.data.resultCode == 0){
            this.phoneJson.sessionid = res.data.sessionid
          }else{
            clearInterval(this.timer)
            this.$message.error(res.data.message)
          }
        })
      }
    },
    mounted() {
      this.getImgCode()
      window.onresize = () => {
        return (() => {
          this.screenWidth = document.body.clientWidth;
          if (this.screenWidth > 750) {
            this.showLeft750 = true
          }
        })();
      }
      if (localStorage.getItem('userInfoId')) {
        this.userinfoId = localStorage.getItem('userInfoId')
        this.getUserInfo()
      }
      if (sessionStorage.getItem('userInfoId')) {
        this.userinfoId = sessionStorage.getItem('userInfoId')
        this.getUserInfo()
      }
      this.getMemberArticaleList(1)
    }

  }
</script>

<style>
</style>


